import { ConfirmDialog } from '../../../components/common/ConfirmDialog';
import {
  EngageLibraryItemTypeEnum,
  EngageLibrarySyncActionEnum,
  PendingMembershipChange,
} from './engage-library-types';
import { EngageLibraryChangeSection } from './EngageLibraryChangeSection';
import styles from './EngageLibrarySaveDialog.module.css';

const TITLE = 'Save changes to this tenant';
const CONFIRM_LABEL = 'Save changes';
const ADD_SECTION_TITLE = 'Add to tenant';
const REMOVE_SECTION_TITLE = 'Remove from tenant';
const AUTOMATION_REMOVAL_WARNING =
  'Removing automations stops them for this tenant and cancels one-time sends that have not started. Sends already in progress will finish.';
const SEGMENT_REMOVAL_WARNING =
  "Segments used by an automation can't be removed and will stay on this tenant.";

interface EngageLibrarySaveDialogProps {
  changes: PendingMembershipChange[];
  onConfirm: () => void;
  onClose: () => void;
}

export function EngageLibrarySaveDialog({ changes, onConfirm, onClose }: EngageLibrarySaveDialogProps) {
  const additions = changes.filter(change => change.action === EngageLibrarySyncActionEnum.SYNC);
  const removals = changes.filter(change => change.action === EngageLibrarySyncActionEnum.UNSYNC);
  const removesAutomations = removals.some(
    change => change.row.type === EngageLibraryItemTypeEnum.AUTOMATION,
  );
  const removesSegments = removals.some(change => change.row.type === EngageLibraryItemTypeEnum.SEGMENT);
  const tone = removals.length > 0 ? 'destructive' : 'default';

  return (
    <ConfirmDialog
      title={TITLE}
      confirmLabel={CONFIRM_LABEL}
      tone={tone}
      onConfirm={onConfirm}
      onClose={onClose}>
      <div className={styles.changes}>
        {additions.length > 0 && (
          <EngageLibraryChangeSection title={ADD_SECTION_TITLE} changes={additions} />
        )}
        {removals.length > 0 && (
          <EngageLibraryChangeSection title={REMOVE_SECTION_TITLE} changes={removals} />
        )}
        {removesAutomations && <p className={styles.warning}>{AUTOMATION_REMOVAL_WARNING}</p>}
        {removesSegments && <p className={styles.warning}>{SEGMENT_REMOVAL_WARNING}</p>}
      </div>
    </ConfirmDialog>
  );
}
